import { useState } from "react";
import ContactForm from "../../Components/ContactForm";
import { motion } from "framer-motion";
const ContactPage = () => {
  const slideInFromBottom = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8, ease: "easeOut" },
  };
  const [email, setEmail] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <>
      <section className="flex flex-col   items-center justify-center lg:h-[324px] md:h-[272px] h-[314px]   overflow-x-hidden  w-full px-4 md:px-[64] ">
        <div className=" lg:h-[108px] absolute  flex flex-col gap-[24px] lg:mt-[240px] md:mt-[174px] mt-[184px] items-center lg:px-[58px]">
          <h1 className=" lg:h-[60px] font-lora font-medium lg:text-[52px] text-[28px]  lg:leading-[60px]  leading-[34px] tracking-[0%] text-center text-[#151515]">
            Contact us
          </h1>
          <p className="w-[354px] h-[24px] font-outfit font-[350] lg:text-[16px] lg:leading-[24px]  text-[12px] leading-[20px] tracking-[0px] text-center text-[#717171]">
            Any question or remarks? Just write us a message!
          </p>
        </div>
      </section>


      <section className="mt-[120px] md:mt-[78px] lg:mt-[96px] flex flex-col justify-center items-center text-center overflow-hidden ">
        <div className="relative lg:w-[1300px] lg:h-[680px] h-[990px] w-[362px] md:w-[706px] md:h-[600px]  space-y-[56px] rounded-[10px] shadow-[0px_0px_50px_30px_#0000000A]   ">
          <div className="relative flex flex-col lg:flex-row md:flex-row items-center justify-between w-full h-full overflow-hidden lg:px-[16px] md:px-[16px] md:gap-[10px] "  >
            {/* Left Section - Image and Content */}
            <div className="relative lg:w-[616px] lg:h-[648px] w-[330px] h-[400px]  md:w-[320px] md:h-[568px] rounded-[10px] lg:p-[56px]     lg:space-y-[10px]" >
              <motion.img
                src="images/Contact/contact1.webp"
                alt="Contact form"
                className="absolute inset-0 w-full h-full object-cover rounded-[10px] "
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 1.02 }}
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              />

              {/* Overlay Content */}
              <div className="relative lg:w-[303px] lg: h-[536px] lg:space-y-[120px] z-10">
                {/* Header Section */}
                <div className="lg:w-[258px] lg:h-[89px]  w-[256px] h-[54px[ lg:space-y-[16px] mt-[32px] px-[37px]">
                  <h1 className="lg:w-[258px] lg:h-[49px] font-lora font-medium lg:text-[38px] lg:leading-[100%]  text-[18px] leading:[26px] tracking-[0px] text-white text-left">
                    Keep in Touch
                  </h1>
                  <p className="lg:w-[258px] lg:h-[24px] font-outfit font-[350] lg:text-[16px] lg:leading-[24px]  text-[12px] leading-[20px] tracking-[0px] text-[#C9C9C9] text-left">
                    Say something to start a live chat
                  </p>
                </div>

                {/* Contact Information Section */}
                <div className="lg:w-[303px] lg:h-[327px]  lg:space-y-[137px]  px-[37px] mt-[32px] ">
                  {/* Contact Details */}
                  <div className="lg:w-[303px] lg:h-[160px] lg:space-y-[32px] mt-[80px]  ">
                    {/* Phone */}
                    <div className="lg:w-[176px] lg:h-[24px] h-[20px] w-[116px] flex items-center lg:gap-[32px]">
                      <img
                        src="images/icon/call.svg"
                        alt="Phone icon"
                        className="lg:w-[18px] lg:h-[18px] w-[14px] h-[14px]"
                      />
                      <a
                        href="tel:+918431276142"
                        className="lg:w-[126px] lg:h-[24px] font-outfit text-[12px] lg:text-[16px] text-white hover:underline whitespace-nowrap px-4"
                      >
                        +91 84312 76142
                      </a>
                    </div>

                    {/* Email */}
                    <div className="lg:w-[176px] lg:h-[24px] flex items-center lg:gap-[32px] mt-[24px]   ">
                      <img
                        src="images/icon/mail.svg"
                        alt="Email icon"
                        className="lg:w-[18px] lg:h-[18px]  w-[14px] h-[14px]"
                      />
                      <a
                        href="mailto:homes@znorm.org"
                        className="lg:w-[126px] lg:h-[24px] font-outfit text-[12px] lg:text-[16px] text-white hover:underline px-4"
                      >
                        homes@znorm.org
                      </a>
                    </div>

                    {/* Address */}
                    <div className="lg:w-[303px] lg:h-[48px] flex items-start lg:gap-[32px] mt-[24px]  px-[16x] ">
                      <img
                        src="images/icon/location.svg"
                        alt="map icon"
                        className="lg:w-[18px] lg:h-[18px]  w-[14px] h-[14px]"
                      />
                      <span className="lg:w-[253px] lg:h-[48px] text-white  font-outfit text-[12px] lg:text-[16px] text-left px-4 ">
                        Znorm Hospitality
                        <br />
                        Znorm Pvt Ltd,
                        <br />
                        Bhartiya City,
                        <br />
                        560064
                      </span>
                    </div>
                  </div>

                  {/* Social Icons */}
                  <div className="lg:w-[76px] lg:h-[30px] flex items-center gap-[16px] mt-[40px]" >
                    <a
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px] h-[30px] flex items-center justify-center rounded-full bg-blue-500 text-white hover:bg-blue-600 transition"
                    >
                      <img src="images/icon/twitter.svg" alt="Twitter" />
                    </a>
                    <a
                      href="https://www.instagram.com/znormhomes/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px] h-[30px] flex items-center justify-center rounded-full bg-white text-[#F24949] "
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section - Form */}
            <motion.div className="lg:w-[556px] w-[362px] lg:mt-[56px] mt-10 h-full  bg-white bg-opacity-80 overflow-hidden" {...slideInFromBottom}>
              <ContactForm />
            </motion.div>
          </div>
        </div>
      </section>
      <section className="w-full flex flex-col justify-center items-center mt-[120px] md:mt-[134px] lg:mt-[200px] overflow-x-hidden lg:h-[356px] md:h-[256px] h-[240px]">
        <div className=" relative w-full h-[240px] md:h-[256px] lg:h-[356px] flex flex-col justify-center items-center bg-blue-400">
          <img
            src="/images/Contact/contact2.webp"
            alt="Contact Image"
            className="absolute  w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="relative flex flex-col items-center justify-center px-4 sm:px-10 lg:w-[532px] md:w-[531px] w-[362px] lg:mt-[74px] md:mt-[55px] mt-8 text-center">
            <h2 className="text-[18px] leading-[26px] lg:text-[38px] md:text-[24px] font-medium text-white font-lora mb-4 whitespace-nowrap">
              Sign up to our Newsletter
            </h2>
            <p className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit mb-4  lg:whitespace-nowrap md:whitespace-nowrap">
              Receive latest news, updates, and many other things
              every week.
            </p>
            <div className="w-full relative flex items-center mt-4 md:mt-10 lg:mt-12 lg:px-6 px-5">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter Your email address"
                className="lg:w-[531px] lg:h-[64px] md:w-[456px] md:h-[48px] w-[300px] h-[44px] p-3 text-lg border-white rounded-full bg-white text-black placeholder-black  outfit-text focus:outline-none focus:ring-2 focus:ring-lime-600 "
              />
              <a
                href={`mailto:homes@znorm.org?subject=Contact&body=From: ${email}`}
                className="absolute  right-8    text-white rounded-[50px] hover:bg-blue-100 transition w-[34px] h-[34px] md:w-[40px] md:h-[40px] lg:w-[48px] lg:h-[48px]  "
                title="Send Email"
              >
                <img
                  src="/images/icon/telegram.svg"
                  alt="Send Email"
                  className="w-full h-full object-cover"
                />
              </a>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
